export default __webpack_public_path__ + "0697040c56e0a596472b8daed14a4425.ttf";